module.exports = __webpack_public_path__ + "img/starpoweer_nomal.49f7fa4a.svg";